import type { ISiteConfig } from '@/contexts/SiteContext'


import Link from '@/components/Link';
const config: ISiteConfig = {
  name: 'Tad AI',
  seoTitle: (title) => {
    return `${title} | ${config.name}`
  },
  supportEmail: 'support@tad.ai',
  analytics: {
    gtmId: 'GTM-5BRCDGRR',
  },
  sessionProviderEnabled: true,
  404: {
    image: (
      <div className='mx-auto w-fit px-4 pb-4 pt-24 md:pt-40'>
        <span className='i-cus--tad-404 size-32' />
      </div>
    ),
    errorText: (
      <p className='text-center text-[64px] font-bold leading-[80px] opacity-65'>
        404
      </p>
    ),
    message: (
      <p className='pb-8 text-base font-bold leading-8 opacity-65'>
        Sorry, The Page Not Found.
      </p>
    ),
    errorButton: (
      <Link
        href='/'
        className='gap-2 rounded-[4px] bg-gradient-to-r from-[#dd3466] via-[#ff4bf3] to-[#8635ff] px-12 py-2 text-lg font-semibold text-white'
      >
        Go Home
      </Link>
    ),
  },
  500: {
    image: (
      <div className='mx-auto w-fit px-4 pb-4 pt-24 md:pt-60'>
        <span className='i-cus--tad-500 size-32' />
      </div>
    ),
    errorText: (
      <p className='text-center text-[64px] font-bold leading-[80px] opacity-65'>
        500
      </p>
    ),
    message: (
      <p className='pb-8 text-base font-bold leading-8 opacity-65'>
        Sorry, Internal Server Error.
      </p>
    ),
    errorButton: (
      <Link
        href='/'
        className='gap-2 rounded-[4px] bg-gradient-to-r from-[#dd3466] via-[#ff4bf3] to-[#8635ff] px-12 py-2 text-lg font-semibold text-white'
      >
        Go Home
      </Link>
    ),
  },
}

export default config
